import clsx from 'clsx';
import React from 'react';

export interface ConversionBarData {
  label: string;
  percentage: number;
  color: string;
}

export interface ConversionChartProps {
  title: string;
  data: ConversionBarData[];
  className?: string;
}

export const ConversionChart: React.FC<ConversionChartProps> = ({
  title,
  data,
  className,
}) => {
  const maxPercentage = Math.max(...data.map((item) => item.percentage));

  return (
    <div className={clsx('bg-white p-6 rounded-lg border border-neutral-200', className)}>
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-neutral-800">{title}</h3>
      </div>

      <div className="flex items-start gap-6 h-80">
        {/* Vertical Bars */}
        <div className="flex-1 flex items-end justify-around gap-4 h-full pb-8">
          {data.map((item, index) => {
            const height = (item.percentage / maxPercentage) * 100;

            return (
              <div key={index} className="flex flex-col items-center gap-3 flex-1 h-full">
                {/* Bar Container */}
                <div className="w-full flex-1 flex items-end">
                  <div
                    className="w-full rounded-t-lg transition-all duration-500 min-h-5"
                    style={{
                      height: `${String(height)}%`,
                      backgroundColor: item.color,
                    }}
                  />
                </div>
                {/* Percentage */}
                <span className="text-sm font-medium text-neutral-700">
                  {item.percentage}%
                </span>
              </div>
            );
          })}
        </div>

        {/* Legend */}
        <div className="flex flex-col gap-3 justify-center min-w-45">
          {data.map((item, index) => (
            <div key={index} className="flex items-center gap-2">
              <div
                className="w-3 h-3 rounded-full shrink-0"
                style={{ backgroundColor: item.color }}
              />
              <span className="text-sm text-neutral-600">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
